import React from 'react';
import ShopCatalog from './ShopCatalog';

export default function ShopAccessories() {
    return <ShopCatalog productType="accessory" key="accessory" />;
}